/* eslint-disable no-undef */
import type {
  ListConversationsResponse,
  GetConversationResponse,
  FeedbackResponse,
} from '../types/agent.types';

const AGENT_API_URL = process.env.NEXT_PUBLIC_AGENT_API_URL;

async function getToken(): Promise<string> {
  return localStorage.getItem('ecToken') || '';
}

async function agentFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
  if (!AGENT_API_URL) throw new Error('Agent API URL not configured');

  const token = await getToken();
  const response = await fetch(`${AGENT_API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });

  if (!response.ok) {
    throw new Error(`Agent API error: ${response.status}`);
  }

  // 204 No Content
  if (response.status === 204) return undefined as T;

  return response.json();
}

export async function listConversations(): Promise<ListConversationsResponse> {
  return agentFetch<ListConversationsResponse>('/conversations');
}

export async function getConversation(conversationId: string): Promise<GetConversationResponse> {
  return agentFetch<GetConversationResponse>(`/conversations/${conversationId}`);
}

export async function deleteConversation(conversationId: string): Promise<void> {
  return agentFetch<void>(`/conversations/${conversationId}`, { method: 'DELETE' });
}

export async function submitFeedback(
  conversationId: string,
  messageId: string,
  rating: 'positive' | 'negative',
  comment?: string
): Promise<FeedbackResponse> {
  return agentFetch<FeedbackResponse>(`/conversations/${conversationId}/feedback`, {
    method: 'POST',
    body: JSON.stringify({ messageId, rating, ...(comment && { comment }) }),
  });
}
